import type { CreditScoreRange } from './types/CreditScoreRange';

export const isValidCreditScoreRange = (
  value: unknown,
): value is CreditScoreRange => {
  const creditScores = [
    '800+',
    '740-799',
    '670-739',
    '580-669',
    '579 or lower',
    // enforce that the array contains all values of `CreditScoreRange`
  ] satisfies ReadonlyArray<CreditScoreRange>;

  return creditScores.includes(value as CreditScoreRange);
};
